import React from 'react'

export default function AmpArticleSectionAd({ index, isR18Article, isLoveSite }) {
  const adNumber = index + 1 <= 10 ? index + 1 : 'n'
  const getAdSlot = () => {
    if (isR18Article) return `/90969475/amp_mobile_18adult_article_middle_${adNumber}`
    if (isLoveSite) return `/90969475/amp_mobile_love_article_middle_${adNumber}`
    return `/90969475/amp_mobile_article_middle_${adNumber}`
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <amp-ad
        width="336"
        height="280"
        type="doubleclick"
        data-slot={getAdSlot()}
        data-multi-size="300x250"
      />
    </div>
  )
}
